import { langutil } from 'language/langutil';
import svcs, { isLangEn, isLangEnUs, isLangKo } from 'services';

export const urls = {
  techSquare: 'https://tech-square.co.kr/',
  lselectricHomepageEnUs: 'https://www.lselectricamerica.com/',
  lselectricHomepageEn: 'https://www.ls-electric.com/',
  lselectricHomepageKo: 'https://www.ls-electric.com/ko',
} as const;

export function openLselectricHompage() {
  if (isLangEnUs()) {
    window.open(urls.lselectricHomepageEnUs, '_blank');
  } else if (isLangEn()) {
    window.open(urls.lselectricHomepageEn, '_blank');
  } else if (isLangKo()) {
    window.open(urls.lselectricHomepageKo, '_blank');
  } else {
    window.open(urls.lselectricHomepageEn, '_blank');
  }
}

export const getAssetInsightUrl = () => {
  return import.meta.env.VITE_ASSET_INSIGHT_URL || 'https://asseti.ls-electric.com';
};

export const getSSQBaseUrl = () => {
  return import.meta.env.VITE_APP_SSQ_URL || 'https://ssq.ls-electric.com';
};

const getSSQMenuPrefixUrl = () => {
  const siteLanguage = svcs.svcLang.getLanguage();
  return `${getSSQBaseUrl()}${langutil.urlPrefix(siteLanguage)}`;
}

export const getQrHelpUrl = () => {
  const menuUrl = `/manual/document`;
  return `${getSSQMenuPrefixUrl()}${menuUrl}`;
};

export const getPrivacyPolicyUrl = () => {
  return `${getSSQMenuPrefixUrl()}/privacypolicy`;
};

/**
 * 메인 페이지 여부 확인
 * @param pathname - URL pathname (예: '/', '/kr/ko/main')
 * @returns 메인 페이지이면 true
 */
export const isMainPage = (pathname: string): boolean => {
  return pathname === '/' || pathname === '' || /^\/\w\w\/\w\w\/main/.test(pathname);
};
